import React from "react";
import { Link } from "react-router-dom";
import { config } from "../../config"; 
import "./SubAdminNoAccess.css";

const SubAdminNoAccess = ({ message }) => {
  return (
    <div className="no-access-wrapper">
      <img
        src={`${config.frontEndBaseUrl}adminAssets/images/no-access.jpg`} 
        alt="No Access"
        className="no-access-image"
      />
      <h2 className="no-access-heading">Access Denied</h2>
      <p className="no-access-text">{message || "You do not have permission to view this page."}</p>
      <Link to="/" className="no-access-button">Go Back Home</Link>
    </div>
  );
};

export default SubAdminNoAccess;
